import Icon from 'veui/components/Icon'
import { IconExternalLink } from 'dls-icons-vue'

Icon.register('external-link', IconExternalLink)
